export { default as Typography, ITypographyProps } from './Typography';
